import { fillArr, randomNum } from '@hglobal/common';
import { CourseStatusType, CourseType } from '@pt/models';

import { GetMemberCoursesRes } from '../models/get-member-courses';

export function getMemberCoursesMock(): GetMemberCoursesRes {
  return {
    itemsCount: 16,
    memberCourses: fillArr(8, i => ({
      id: i,
      courseId: i,
      courseName: `Course ${i}`,
      courseType: [CourseType.Open, CourseType.Request, CourseType.Mandatory][randomNum(2)],
      courseStatus: [
        CourseStatusType.Completed,
        CourseStatusType.InProgress,
        CourseStatusType.NotStarted,
        CourseStatusType.NotPassed,
      ][randomNum(3)],
    })),
  };
}
